var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrofonPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "microfon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "url(#paint0_linear_1454_1090)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"microphone\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.025 58.1566C54.709 58.1566 58.506 54.473 58.506 49.9289V36.216C58.506 31.6719 54.709 27.9883 50.025 27.9883C45.3411 27.9883 41.544 31.6719 41.544 36.216V49.9289C41.544 54.473 45.3411 58.1566 50.025 58.1566ZM64.16 44.4437H62.7465C61.9655 44.4437 61.333 45.0574 61.333 45.815V49.9289C61.333 56.3397 55.6357 61.4837 48.8951 60.8461C43.0203 60.2898 38.7171 55.1664 38.7171 49.4404V45.815C38.7171 45.0574 38.0845 44.4437 37.3036 44.4437H35.8901C35.1091 44.4437 34.4766 45.0574 34.4766 45.815V49.257C34.4766 56.9396 40.1279 63.7883 47.9048 64.8288V67.7556H42.9575C42.1766 67.7556 41.544 68.3693 41.544 69.1269V70.4982C41.544 71.2559 42.1766 71.8695 42.9575 71.8695H57.0925C57.8735 71.8695 58.506 71.2559 58.506 70.4982V69.1269C58.506 68.3693 57.8735 67.7556 57.0925 67.7556H52.1453V64.8614C59.7172 63.8535 65.5735 57.5481 65.5735 49.9289V45.815C65.5735 45.0574 64.941 44.4437 64.16 44.4437Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1454_1090",
    x1: 134.872,
    y1: 81.7626,
    x2: 93.5963,
    y2: 131.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrofonPurple);
export default __webpack_public_path__ + "static/media/microfon-purple.c479a91a8f3309edaf46d3f98464ee22.svg";
export { ForwardRef as ReactComponent };